'use strict'

export function passPropToAddonSlideshow (html, prop) {
  return html.replace(/addon-slideshow" /g, `addon-slideshow" ${prop}="${prop}" `)
}

export function passPropToAddonYouTube (html, prop) {
  return html.replace(/addon-youtube" /g, `addon-youtube" ${prop}="${prop}" `)
}

export function passPropToAddonVimeo (html, prop) {
  return html.replace(/addon-vimeo" /g, `addon-vimeo" ${prop}="${prop}" `)
}



// WEBPACK FOOTER //
// ./app/components/nn-add-ons/compile-helpers.js